export function HelpQueryCardSkeleton() {
  return (
    <div className="space-y-2 rounded-3xl border border-muted p-3">
      <div className="h-3 w-20 animate-pulse rounded bg-[#F0E0C7]/60" />
      <div className="h-4 w-40 animate-pulse rounded bg-[#F0E0C7]/60" />
      <div className="h-10 w-full animate-pulse rounded bg-[#F0E0C7]/60" />
      <div className="h-3 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
    </div>
  );
}

export default function HelpQueriesSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <HelpQueryCardSkeleton key={`help-query-${index}`} />
      ))}
    </div>
  );
}
